import graphqlClient from "../../../apollo";

class ProveedorProvider {

    findProveedor(id) {
        return graphqlClient.query({
            query: require('./gql/proveedorFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchProveedores() {
        return graphqlClient.query({
            query: require('./gql/proveedorFetch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateProveedores(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/proveedorPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }

    createProveedor(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/proveedorCreate.graphql'),
            variables: form
        })
    }

    updateProveedor(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/proveedorUpdate.graphql'),
            variables: form
        })
    }

    deleteProveedor(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/proveedorDelete.graphql'),
            variables: { id }
        })
    }

}

export default new ProveedorProvider()
